var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "contentBlock" }, [
      _c("div", { staticClass: "viewHeader" }, [
        _c("span", { staticClass: "header" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                _vm.isLogoProduct
                  ? _vm.$t("views.importSelect.select_logo")
                  : _vm.$t("views.importSelect.select_photo")
              ) +
              "\n\t\t\t"
          ),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "subHeader" }, [
          _vm._v(
            "\n\t\t\t\t" +
              _vm._s(
                !_vm.isLogoProduct && _vm.selectionCount < _vm.maxPhotos
                  ? _vm.$t("importStatusBelowMax", {
                      count: _vm.maxPhotos - _vm.selectionCount,
                    })
                  : ""
              ) +
              "\n\t\t\t"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttonContainer" },
        [
          _c(
            "button",
            {
              staticClass: "focusButton",
              on: {
                click: function ($event) {
                  return _vm.clickChannel("upload")
                },
              },
            },
            [
              _c("i", { staticClass: "material-icons mobile" }, [
                _vm._v("\n\t\t\t\t\tphone_iphone\n\t\t\t\t"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "mobile text" }, [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.$t("step2SelectionImportButtonA")) +
                    "\n\t\t\t\t"
                ),
              ]),
              _vm._v(" "),
              _c("i", { staticClass: "material-icons desktop" }, [
                _vm._v("\n\t\t\t\t\tdesktop_mac\n\t\t\t\t"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "desktop text" }, [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.$t("step2SelectionImportButtonB")) +
                    "\n\t\t\t\t"
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.photoSources, function (channel) {
            return _c(
              "button",
              {
                key: channel.id,
                staticClass: "otherButton",
                on: {
                  click: function ($event) {
                    return _vm.clickChannel(channel.id)
                  },
                },
              },
              [
                channel.id === "qr"
                  ? _c("i", { staticClass: "material-icons" }, [
                      _vm._v("\n\t\t\t\t\tqr_code_scanner\n\t\t\t\t"),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                channel.id === "qr"
                  ? _c("span", { staticClass: "text" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("views.importSelect.QR_uploadButton")) +
                          "\n\t\t\t\t"
                      ),
                    ])
                  : channel.id == "facebook"
                  ? _c("span", { staticClass: "facebookImage" })
                  : channel.id == "instagram"
                  ? _c("span", { staticClass: "instagramImage" })
                  : channel.id == "dropbox"
                  ? _c("span", { staticClass: "dropboxImage" })
                  : channel.id == "gplus"
                  ? _c("span", { staticClass: "googleImage" })
                  : channel.id == "app"
                  ? _c("span", { staticClass: "appIcon" })
                  : channel.id == "microsoft"
                  ? _c("span", { staticClass: "microsoftImage" })
                  : _vm._e(),
                _vm._v(" "),
                channel.id == "app"
                  ? _c("span", { staticClass: "appName" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("channelApp")) +
                          "\n\t\t\t\t"
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          _vm.skipButtonText
            ? _c(
                "button",
                { staticClass: "skipButton", on: { click: _vm.skipSelection } },
                [_vm._v("\n\t\t\t\t" + _vm._s(_vm.skipButtonText) + "\n\t\t\t")]
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }